import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {BaseComponent, CommonService} from '@rubii/frontend-common';
import {ConfigService} from '../../services/config.service';
import {ItemResponse} from '@rubii/frontend-common/lib/models/common/Response';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-join',
  templateUrl: './join.component.html',
  styleUrls: ['./join.component.scss']
})
export class JoinComponent extends BaseComponent implements OnInit {

    sent = false;
    nameFormControl: FormControl;
    emailFormControl: FormControl;
    companyFormControl: FormControl;


  constructor(private configService: ConfigService, private commonService: CommonService, private snackBar: MatSnackBar) {
      super();
      this.nameFormControl = new FormControl('', [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(255)
      ]);
      this.emailFormControl = new FormControl('', [
          Validators.required,
          Validators.email,
          Validators.maxLength(100)
      ]);
      this.companyFormControl = new FormControl('', [
      ]);

  }

  ngOnInit() {
  }

  join() {
      
  }
}
